module.exports = __webpack_public_path__ + "static/img/videotext.7724475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiperpic/videotext.png
// module id = U0Zh
// module chunks = 51